if (!customElements.get('ask-modal')) {
  class AksModal extends HTMLElement {
    constructor() {
      super();
  
      this.tabs = this.querySelectorAll('[data-target]');
      this.tabsContent = this.querySelectorAll('[data-content]');
      this.chatButton = this.querySelector('[data-open-chat]');
      this.modalId = this.getAttribute('modal-id');
      this.modalElement = document.querySelector(`#${this.modalId}`);
    }
  
    connectedCallback() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-target');
  
          this.tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          
          this.tabsContent.forEach(content => {
            if (content.getAttribute('data-content') === target) {
              content.removeAttribute('hidden');
            } else {
              content.setAttribute('hidden', '');
            }
          });
        });
      });
  
      this.chatButton.addEventListener('click', () => {
        const inboxElement = document.querySelector('inbox-online-store-chat');
  
        this.modalElement.hide();
  
        if (inboxElement && inboxElement.shadowRoot) {
          const chatToggleButton = inboxElement.shadowRoot.querySelector('button.chat-toggle');
          if (chatToggleButton) {
            chatToggleButton.click();
            
          } else {
            console.warn('Przycisk czatu nie znaleziony w shadowRoot');
          }
        } else {
          console.warn('Element inbox-online-store-chat lub jego shadowRoot nie istnieje jeszcze');
        }
      });
    }
  }

  customElements.define('ask-modal', AksModal);
}

(function initAlmiContactMetadata() {
  if (window.AlmiContactMetadata?.initialized) return;

  const state = {
    product: null,
    currentVariant: null,
    productPromise: null
  };

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeId(value) {
    return String(value || '')
      .replace(/^gid:\/\/shopify\/(?:ProductVariant|Product)\//, '')
      .trim();
  }

  function getProductJsonUrl() {
    const url = new URL(window.location.href);
    const productPathMatch = url.pathname.match(/^(.*\/products\/[^/]+)\/?$/);
    if (!productPathMatch) return '';

    url.pathname = `${productPathMatch[1]}.js`;
    url.search = '';
    url.hash = '';
    return url.toString();
  }

  function readVariantFromTheme() {
    const script = document.querySelector(
      '.shopify-section--main-product variant-picker script[data-variant], variant-picker script[data-variant]'
    );

    if (!script?.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getVariantIdFromForm(form) {
    const contactVariantId = Array.from(form?.elements || []).find(
      (element) => element.name === 'contact[variant_id]' && element.value
    );

    if (contactVariantId) return normalizeId(contactVariantId.value);
    if (state.currentVariant?.id) return normalizeId(state.currentVariant.id);

    const themeVariant = readVariantFromTheme();
    if (themeVariant?.id) return normalizeId(themeVariant.id);

    const productFormVariant = document.querySelector(
      '.shopify-section--main-product form[action*="/cart/add"] input[name="id"], .shopify-section--main-product product-form input[name="id"]'
    );

    if (productFormVariant?.value) return normalizeId(productFormVariant.value);

    return normalizeId(new URLSearchParams(window.location.search).get('variant'));
  }

  function findCurrentVariant(form) {
    const variantId = getVariantIdFromForm(form);

    if (state.currentVariant && (!variantId || normalizeId(state.currentVariant.id) === variantId)) {
      return state.currentVariant;
    }

    const themeVariant = readVariantFromTheme();
    if (themeVariant && (!variantId || normalizeId(themeVariant.id) === variantId)) {
      return themeVariant;
    }

    if (state.product?.variants?.length) {
      const matchedVariant = state.product.variants.find(
        (variant) => normalizeId(variant.id) === variantId
      );

      if (matchedVariant) return matchedVariant;
      if (!variantId && state.product.variants.length === 1) return state.product.variants[0];
    }

    return state.currentVariant || themeVariant || null;
  }

  function getProductTitle() {
    if (state.product?.title) return cleanText(state.product.title);

    const title = document.querySelector(
      '.shopify-section--main-product h1.product-title'
    );

    if (title?.textContent) return cleanText(title.textContent);

    const ogTitle = document.querySelector('meta[property="og:title"]')?.content;
    return cleanText(ogTitle);
  }

  function getSkuFromDom() {
    const skuElement = document.querySelector(
      '.shopify-section--main-product variant-sku, variant-sku'
    );

    if (!skuElement?.textContent) return '';

    return cleanText(skuElement.textContent).replace(/^SKU\s*:?\s*/i, '');
  }

  function upsertHidden(form, name, value) {
    if (!form) return;

    let input = Array.from(form.elements || []).find(
      (element) => element.type === 'hidden' && element.name === name
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value == null ? '' : String(value);
  }

  function enrichForm(form) {
    if (!form?.matches('form.ask-modal-form, form.personalize-options-form')) return;

    const variant = findCurrentVariant(form);
    const productIdFromForm = Array.from(form.elements || []).find(
      (element) => element.name === 'contact[product_id]' && element.value
    )?.value;

    const productId = normalizeId(state.product?.id || productIdFromForm || variant?.product_id);
    const variantId = normalizeId(variant?.id || getVariantIdFromForm(form));
    const productTitle = getProductTitle();
    let variantTitle = cleanText(variant?.title);
    const sku = cleanText(variant?.sku || getSkuFromDom());

    if (!variantTitle) {
      variantTitle = cleanText(document.querySelector('#selected-variant-info')?.textContent);
    }

    if (!variantTitle && !document.querySelector('variant-picker')) {
      variantTitle = 'Brak osobnego wariantu';
    }

    if (variantTitle.toLowerCase() === 'default title') {
      variantTitle = 'Brak osobnego wariantu';
    }

    upsertHidden(form, 'contact[Produkt]', productTitle);
    upsertHidden(form, 'contact[Wariant]', variantTitle);
    upsertHidden(form, 'contact[SKU]', sku);
    upsertHidden(form, 'contact[product_id]', productId);
    upsertHidden(form, 'contact[variant_id]', variantId);
    upsertHidden(form, 'contact[URL produktu]', window.location.href);
  }

  function prefetchProduct() {
    if (state.productPromise) return state.productPromise;

    const themeVariant = readVariantFromTheme();
    if (themeVariant?.id) {
      state.currentVariant = themeVariant;
    }

    const variantId = getVariantIdFromForm(null);
    const skuFromTheme = cleanText(themeVariant?.sku || getSkuFromDom());

    if (variantId && skuFromTheme) {
      state.productPromise = Promise.resolve(null);
      document.querySelectorAll('form.ask-modal-form, form.personalize-options-form').forEach(enrichForm);
      return state.productPromise;
    }

    const productJsonUrl = getProductJsonUrl();
    if (!productJsonUrl) {
      state.productPromise = Promise.resolve(null);
      return state.productPromise;
    }

    state.productPromise = fetch(productJsonUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => {
        state.product = product;

        const selectedVariantId = getVariantIdFromForm(null);
        if (product?.variants?.length) {
          state.currentVariant = product.variants.find(
            (variant) => normalizeId(variant.id) === selectedVariantId
          ) || (product.variants.length === 1 ? product.variants[0] : state.currentVariant);
        }

        document.querySelectorAll('form.ask-modal-form, form.personalize-options-form').forEach(enrichForm);
        return product;
      })
      .catch(() => null);

    return state.productPromise;
  }

  document.addEventListener('variant:change', (event) => {
    if (event.detail?.variant) state.currentVariant = event.detail.variant;
  }, true);

  document.addEventListener('product:variant-change', (event) => {
    if (event.detail?.variant) state.currentVariant = event.detail.variant;
  }, true);

  document.addEventListener('click', (event) => {
    const submitButton = event.target.closest('button[type="submit"], input[type="submit"]');
    if (!submitButton) return;

    const form = submitButton.form || submitButton.closest('form');
    enrichForm(form);
  }, true);

  document.addEventListener('submit', (event) => {
    enrichForm(event.target);
  }, true);

  window.AlmiContactMetadata = {
    initialized: true,
    state,
    enrichForm,
    prefetchProduct
  };

  prefetchProduct();
})();
